<template>
  <div class="type-layout">
    <div class="inner">
      <div v-if="!isMobile" class="paradigm_page_container">
        <div class="paradigm_home_product">
          <div class="paradigm_home_subTitle animated fadeInDown slow">
            <div class="paradigm_home_subTitle__title">面试全类型支持</div>
            <div class="paradigm_home_subTitle__memo">更多选择，更多惊喜</div>
          </div>
          <div class="paradigm_home_product__content">
            <div class="paradigm_home_product__left animated fadeInLeft slow">
              <div
                class="paradigm_home_product__list__item"
                @mouseover="mouseoverHandler(1)"
                v-bind:class="{ active: isActive == 1 }"
              >
                <span>01</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>一对一在线面试</span>
              </div>
              <div
                class="paradigm_home_product__list__item"
                @mouseover="mouseoverHandler(2)"
                v-bind:class="{ active: isActive == 2 }"
              >
                <span>02</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>多对一在线面试</span>
              </div>
              <div
                class="paradigm_home_product__list__item"
                @mouseover="mouseoverHandler(3)"
                v-bind:class="{ active: isActive == 3 }"
              >
                <span>03</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>多对多在线面试</span>
              </div>
              <div
                class="paradigm_home_product__list__item"
                @mouseover="mouseoverHandler(4)"
                v-bind:class="{ active: isActive == 4 }"
              >
                <span>04</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>手机端在线面试</span>
              </div>
            </div>
          </div>
          <a class="btn" style="margin-top: 30px" @click="goTry">试用</a>
          <div class="paradigm_home_product__mac">
            <div
              class="paradigm_home_product__mac__containner animated fadeInRight slow"
            >
              <div class="map1" v-if="isActive == 1">
                <img src="@/static/images/interview-1-1.png" />
              </div>
              <div class="map1" v-if="isActive == 2">
                <img src="@/static/images/interview-1-2.png" />
              </div>
              <div class="map1" v-if="isActive == 3">
                <img src="@/static/images/interview-1-3.png" />
              </div>
              <div class="map1" style="margin-top: -100px" v-if="isActive == 4">
                <img src="@/static/images/interview-1-4.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="mobile-type">
        <div class="mobile-type-title animated fadeInDown slow">
          <div>面试全类型支持</div>
          <div class="mobile-types__memo">更多选择，更多惊喜</div>
        </div>
        <el-carousel
          class="mobile-type-carousel"
          :interval="5000"
          arrow="always"
        >
          <el-carousel-item v-for="(item, index) in titleList" :key="index">
            <div class="carousel-title">{{ item.label }}</div>
            <el-image :src="item.pic" cover></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 1,
      isMobile: false,
      titleList: [
        {
          label: '1 一 一对一在线面试',
          pic: '/static/images/interview-1-1.png',
        },
        {
          label: '2 一 多对一在线面试',
          pic: '/static/images/interview-1-2.png',
        },
        {
          label: '3 一 多对多在线面试',
          pic: '/static/images/interview-1-3.png',
        },
        {
          label: '4 一 手机端在线面试',
          pic: '/static/images/interview-1-4.png',
        },
      ],
      isPcDialogShow: false,
    }
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
  },
  methods: {
    mouseoverHandler(num) {
      this.isActive = num
    },
    goTry() {
      //试用
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose2')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.paradigm_page_container {
  margin: 0px auto;
  width: 1200px;
}
.type-layout {
  display: grid;
  height: 100%;
  .inner {
    margin: auto;
    position: relative;
    top: -30px;
  }
}
.slow {
  animation-duration: 2s;
}
.tiyanbtn {
  padding: 50px 0px 0px;
  cursor: pointer;
}
.tiyanbtn a {
  padding: 8px 15px;
  background: #29bdb9;
  color: #fff;
  border-radius: 20px;
}
.paradigm_home_subTitle {
  font-size: 36px;
  font-weight: 300;
}
.paradigm_home_product .paradigm_home_product__list__item {
  line-height: 49px;
  cursor: pointer;
  font-size: 20px;
  color: rgba(51, 51, 51, 0.5);
  font-weight: 300;
  transition: all 0.1s;
}
.paradigm_home_product__list__item.active
  .paradigm_home_product__list__item__symble {
  transform: rotate(68deg);
  margin-top: -5px;
  vertical-align: top;
  padding-left: 20px;
}
.paradigm_home_subTitle .paradigm_home_subTitle__memo {
  margin-top: 20px;
  font-size: 14px;
}
.paradigm_home_product .paradigm_home_product__content {
  display: flex;
}
.paradigm_home_product .paradigm_home_product__left {
  width: 500px;
  padding-top: 74px;
  box-sizing: border-box;
}
.paradigm_home_product .paradigm_home_product__mac {
  width: 100%;
  margin-top: -330px;
  background-size: cover;
  background-position: center;
}
.paradigm_home_product
  .paradigm_home_product__mac
  .paradigm_home_product__mac__containner {
  width: 700px;
  background-size: cover;
  box-sizing: border-box;
  float: right;
}
.paradigm_home_product
  .paradigm_home_product__mac
  .paradigm_home_product__mac__containner
  .map1 {
  text-align: center;
  max-height: 570px;
  max-width: 600px;
}
.paradigm_home_product
  .paradigm_home_product__mac
  .paradigm_home_product__mac__containner
  .map1
  img {
  max-height: 570px;
  max-width: 600px;
}
.paradigm_home_product__text__containner {
  background: url('~@/static/images/home-three-bottom.png');
  background-size: cover;
  width: 600px;
  font-size: 12px;
  line-height: 23px;
  padding: 45px 20px 45px 35px;
  float: right;
  margin: 20px 50px 0px 0px;
  height: 179px;
}
.paradigm_home_product__text__containner span {
  color: #29bdb9;
  font-weight: bold;
}
.paradigm_home_product .paradigm_home_product__list__item {
  line-height: 49px;
  cursor: pointer;
  font-size: 20px;
  color: rgba(51, 51, 51, 0.5);
  font-weight: 300;
  transition: all 0.1s;
}
.paradigm_home_product
  .paradigm_home_product__list__item
  .paradigm_home_product__list__item__symble {
  display: inline-block;
  padding-right: 12px;
  transition: all 0.3s;
}
.paradigm_home_product .paradigm_home_product__list__item:hover,
.paradigm_home_product .paradigm_home_product__list__item.active {
  color: #333333;
  font-size: 24px;
}
</style>
<style lang="scss">
.mobile-type {
  text-align: center;
  color: #333;
  font-weight: 320;
  height: 460px;
  font-size: 24px;
  margin-top: -40px;
  .mobile-type-title {
    padding-top: 80px;
  }
  .mobile-types__memo {
    font-size: 12px;
    padding: 5px;
    color: #666;
  }
  .el-carousel,
  .mobile-type-carousel {
    .carousel-title {
      padding-top: 20px;
    }
    .el-image {
      padding: 20px;
    }
  }
}
</style>
<style lang='scss'>
@media screen and (max-width: 600px) {
  .type-layout {
    display: block !important;
    margin-top: 40px;
    .el-carousel__container {
      height: 320px;
      .el-carousel__arrow {
        top: 11.8% !important;
        background-color: rgba(31, 45, 61, 0.00001);
        color: #333;
        font-size: 28px !important;
      }

      .el-carousel__indicators--horizontal {
        display: none;
      }
    }
    .el-carousel__indicators--horizontal {
      display: none;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .mobile-type {
    height: 500px;
    width: 450px;
    margin: auto;
  }
  .type-layout {
    display: block !important;

    .el-carousel__container {
      height: 700px !important;
      text-align: center;
      .el-carousel__arrow {
        top: 6% !important;
        background-color: rgba(31, 45, 61, 0.00001);
        color: #333;
        font-size: 28px !important;
      }

      .el-carousel__indicators--horizontal {
        display: none;
      }
      .el-carousel__item {
        .carousel-title {
          font-size: 24px;
        }
      }
    }
    .el-carousel__indicators--horizontal {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/interview/type.vue